import { useCallback, useRef } from "react";
import api from "../api";

const SEARCH_FIELDS = ["nome", "cognome", "codiceFiscale"];

export const trainerToOption = (trainer) => ({
  value: trainer.codiceFiscale,
  label: `${trainer.nome ?? ""} ${trainer.cognome ?? ""} - ${
    trainer.codiceFiscale ?? ""
  }`.trim(),
  trainer,
});

const useTrainerSearch = () => {
  const abortControllerRef = useRef(null);

  const loadOptions = useCallback(
    async (inputValue) => {
      const query = inputValue?.trim();
      if (!query) {
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
          abortControllerRef.current = null;
        }
        return [];
      }

      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const controller = new AbortController();
      abortControllerRef.current = controller;

      try {
        const response = await api.get("/trainers", {
          params: {
            page: 0,
            size: 10,
            nome_like: query,
            $or_cognome_like: query,
            $or_codiceFiscale_like: query,
          },
          signal: controller.signal,
        });

        const trainers = Array.isArray(response.data?.content)
          ? response.data.content
          : Array.isArray(response.data)
          ? response.data
          : [];

        const unique = new Map();
        trainers.forEach((trainer) => {
          if (trainer?.id && !unique.has(trainer.id)) {
            unique.set(trainer.id, trainer);
          }
        });

        return Array.from(unique.values()).map(trainerToOption);
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error(error);
        }
        return [];
      }
    },
    []
  );

  return loadOptions;
};

export default useTrainerSearch;

